export default "__VITE_ASSET__B$zyg4nu__"